"use client";

import { createContext, useMemo } from "react";
import { NextIntlClientProvider } from "next-intl";
import { ReactQueryClientProvider } from "@/lib/query-client-provider";
import { useLanguageChange } from "@/hooks/useLanguageChange";
import GlobalErrorBoundary from "@/components/features/shared/GlobalErrorBoundary";
import { TranslationProvider } from "@/context/TranslationContext";

export const LanguageContext = createContext<{
  switchLanguage: (locale: string) => void;
}>({ switchLanguage: () => {} });

export function Providers({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const { locale, messages, switchLanguage } = useLanguageChange();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const contextValue = useMemo(() => ({ switchLanguage }), [switchLanguage]);

  return (
    <>
      {Object.keys(messages).length > 0 && (
        <LanguageContext.Provider value={contextValue}>
          <NextIntlClientProvider
            timeZone={timeZone}
            messages={messages}
            locale={locale}
          >
            <ReactQueryClientProvider>
              <TranslationProvider>
                <GlobalErrorBoundary>{children}</GlobalErrorBoundary>
              </TranslationProvider>
            </ReactQueryClientProvider>
          </NextIntlClientProvider>
        </LanguageContext.Provider>
      )}
    </>
  );
}
